<template>
    <v-table    ref="table"
                :items-provider="provider"
                :initial-load="false"
                :fields="fields"
                pagination="server"
                class="table-netsis"
                :excel-callback="exportExcel"
                search>
                    <template #additional-actions>
                        <div class="row">
                            <div class="col-md-2 mb-1 mb-md-0">
                                <select class="form-control" v-model="month">
                                    <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-2 mb-1 mb-md-0">
                                <select class="form-control" v-model="year">
                                    <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                                </select>
                            </div>
                            <!-- <div class="col-md-2 mb-1 mb-md-0">
                                <v-select-list :options="branches" label="Name" v-model="branch" placeholder="TÜM ŞUBELER"></v-select-list>
                            </div> -->
                            <div class="col-md-auto mb-1 mb-md-0">
                                <button class="btn btn-success btn-block" v-on:click="fetch">
                                    Sorgula
                                </button>
                            </div>
                        </div>
                    </template>
                </v-table>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations' 
import CompanyApi from '@/api/company'
import moment from 'moment'
import Additional from '@/utilities/additional'

export default {
    props:{
        months:Array,
    },
    data(){
        return {
            fields:[
                {name:"Puantaj Detayı",thClass:'w-100',component:true,componentOptions:{name:"netsis-puantaj/NetsisPuantaj"}}
            ],
            branches:[],
            branch:null,
            year:null,
            years:[],
            month:null,
            searchQuery:null,
        }
    },
    mounted(){
        this.getBranches()
        this.getCurrentYear()
        this.configureYears()
        this.getCurrentMonth()
    },
    methods:{
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
        provider(data){
            return EmployeeOperationsApi.Score.NetsisPuantaj({
                PaginateRequest:data,
                BranchId:this.branch?.Id || null,
                Month:this.month,
                Year:this.year,
                Driver:true
            })
        },
        getCurrentYear(){
            this.year = moment().format('YYYY')
            this.showingYear = this.year
        },
        fetch(){
            this.$refs.table.refresh()
        },
        configureYears(){
            let years = []
            let year = 2015
            while(year <= this.year){
                years.push(year)
                year ++
            }
            this.years = years
        },
        getCurrentMonth(){
            let current = moment().month() + 1
            this.month = this.months.find(m=>m.index == current)?.index || 0
            this.showingMonth = this.month
        },
        exportExcel(){
            this.$refs.table.setExcelLoading(true)
            EmployeeOperationsApi.Score.NetsisPuantajExcel({
                PaginateRequest:{
                    Skip: 1,
                    Take: 10,
                    IsAscending: false,
                    OrderColumnName: null,
                    QueryParam: this.searchQuery,
                },
                BranchId:this.branch?.Id || null,
                Month:this.month,
                Year:this.year,
                Driver:true
            }).then(res=>{
                if(res.data.Success){
                    Additional.GetBlobFile(res.data.Data).then(f=>{
                        Additional.DownloadFile(f.data,`NETSIS-SURUCU-${this.month}-${this.year}.xlsx`)
                        this.$refs.table.setExcelLoading(false)
                    }).catch(err=>{
                        this.$result(null,err)
                        this.$refs.table.setExcelLoading(false)
                    })
                }
                this.$result(res)
            }).catch(err=>{
                this.$refs.table.setExcelLoading(false)
                this.$result(null,err)
            })
        }
    }
}
</script>

<style>
.table-netsis tbody tr:hover{
    background-color: transparent !important;
}
</style>